__webpack_require__.p = "/portofolio-app/";